import { reqAPI } from "../utils/fetch-request";

export async function registerAccount(formData) {
  return reqAPI("api/merchant/register", formData, "POST", true);
}

export async function loginMerchant(formData) {
  return reqAPI("api/merchant/login", formData, "POST", true);
}

export async function verifyOTP(formData) {
  return reqAPI("api/merchant/verify-otp", formData, "POST", true);
}

export async function resendOTP(formData) {
  return reqAPI("api/merchant/resend-otp", formData, "POST", true);
}

export async function forgotPassword(formData) {
  return reqAPI("api/merchant/forgot-password", formData, "POST", true);
}

export async function resetPassword(formData) {
  return reqAPI("api/merchant/reset-password", formData, "POST", true);
}

export async function setPassword(formData) {
  return reqAPI("api/merchant/set-password", formData, "POST");
}

export async function getProfile() {
  return reqAPI("api/merchant/profile");
}

export async function changePassword(formData) {
  return reqAPI(`api/merchant/change-password`, formData, "POST", true);
}

export async function changeEnvironment(formData) {
  const response = await reqAPI(
    `api/merchant/change-environment`,
    formData,
    "POST",
    true
  );
  return response;
}

export async function logoutMerchant() {
  return reqAPI("api/merchant/logout", {}, "POST", false);
}
